import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <button onClick={() => scrollToSection('home')} className="hover:opacity-80 transition-opacity cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/7b8bc41f7bc46c6a685a4edbcf687887.png" 
                alt="Axloweb" 
                className="h-12 w-auto"
              />
            </button>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              {t('nav.home')}
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              {t('nav.portfolio')}
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              {t('nav.contact')}
            </button>
            
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-global-line text-lg w-5 h-5 flex items-center justify-center"></i>
              <span className="font-medium">{currentLang === 'en' ? 'ES' : 'EN'}</span>
            </button>

            <a
              href="https://axloweb.com/axlowebmessagecenter/frontend/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              title="Message Center (Admin)"
            >
              <i className="ri-message-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
              <span className="font-medium">Message Center</span>
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.home')}
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.portfolio')}
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
              {t('nav.contact')}
            </button>
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 w-full px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-global-line text-lg w-5 h-5 flex items-center justify-center"></i>
              <span className="font-medium">{currentLang === 'en' ? 'Español' : 'English'}</span>
            </button>
            <a
              href="https://axloweb.com/axlowebmessagecenter/frontend/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
              <span className="font-medium">Message Center</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
